document.addEventListener('DOMContentLoaded', function() {
  
  // Cerchiamo TUTTE le sezioni di questo tipo sulla pagina
  const pillSections = document.querySelectorAll('.koji-pills-wrapper');

  pillSections.forEach(section => {
    
    // =========================================
    // ANIMAZIONE PUSH-DOWN E CHAT KOJI
    // =========================================
    const header = section.querySelector('.koji-pills-dynamic-header');
    const welcomeContainer = section.querySelector('.koji-welcome-container');
    const avatarWrap = section.querySelector('.koji-icon-wrap');
    const bubble = section.querySelector('.koji-speech-bubble');
    const textElement = section.querySelector('.koji-typewriter-text');
    
    if (bubble && textElement) {
      if (textElement.getAttribute('data-typing-active') === 'true') return;
      textElement.setAttribute('data-typing-active', 'true');

      // Funzione per decodificare entità HTML (Es: L&#39;egoismo -> L'egoismo)
      const decodeHTML = (html) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
      };

      const rawData = decodeHTML(textElement.getAttribute('data-raw-text').trim());
      const quotesArray = rawData.split('[SPLIT]').filter(quote => quote.trim() !== '');
      
      if (quotesArray.length > 0) {
        const randomQuote = quotesArray[Math.floor(Math.random() * quotesArray.length)].trim();
        const textChars = Array.from(randomQuote);
        textElement.innerHTML = ''; 
        
        setTimeout(() => {
          if (header) header.classList.add('is-ready');
          if (welcomeContainer) welcomeContainer.classList.add('is-ready');
          if (avatarWrap) avatarWrap.classList.add('is-popped');
          
          setTimeout(() => {
            bubble.classList.add('is-visible');
            
            setTimeout(() => {
              let i = 0;
              const cursor = document.createElement('span');
              cursor.className = 'typewriter-cursor';
              cursor.setAttribute('aria-hidden', 'true');
              textElement.appendChild(cursor);
              
              const typeInterval = setInterval(() => {
                if (i < textChars.length) {
                  const textNode = document.createTextNode(textChars[i]);
                  textElement.insertBefore(textNode, cursor);
                  i++;
                } else {
                  clearInterval(typeInterval);
                  setTimeout(() => cursor.remove(), 3000);
                }
              }, 25); 
            }, 400); 
          }, 400); 
        }, 1200); 
      }
    }

    // =========================================
    // LOGICA TRACK E TIMELINE ALFABETICA
    // =========================================
    const trackContainers = section.querySelectorAll('.koji-pills-track-container');

    trackContainers.forEach(container => {
      const track = container.querySelector('.koji-pills-track');
      const prevBtn = container.querySelector('.koji-pills-prev');
      const nextBtn = container.querySelector('.koji-pills-next');
      
      const sectionInner = container.closest('.koji-pills-inner');
      const timelineContainer = sectionInner ? sectionInner.querySelector('.koji-alphabet-timeline') : null;
      const timelineMainContainer = sectionInner ? sectionInner.querySelector('.koji-alphabet-timeline-container') : null;

      if (track) {
        const items = Array.from(track.querySelectorAll('.koji-pill-item'));
        
        // Ordina alfabeticamente gli elementi
        items.sort((a, b) => {
          const titleA = a.querySelector('.koji-pill-title-under').textContent.trim().toUpperCase();
          const titleB = b.querySelector('.koji-pill-title-under').textContent.trim().toUpperCase();
          return titleA.localeCompare(titleB);
        });

        const availableLetters = [];

        items.forEach(item => {
          const title = item.querySelector('.koji-pill-title-under').textContent.trim();
          const letter = title.charAt(0).toUpperCase();
          
          item.setAttribute('data-letter', letter);
          
          if (!availableLetters.includes(letter)) {
            availableLetters.push(letter);
          }
          track.appendChild(item);
        });
        
        track.scrollLeft = 0;

        if (timelineContainer && availableLetters.length > 0) {
          const fullAlphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split('');
          let timelineHTML = '<div class="koji-timeline-wrapper">';
          
          fullAlphabet.forEach(l => {
            if (availableLetters.includes(l)) {
              timelineHTML += `<span class="koji-timeline-letter has-content" data-target-letter="${l}">${l}</span>`;
            } else {
              timelineHTML += `<span class="koji-timeline-letter is-empty">${l}</span>`;
            }
          });
          
          timelineHTML += '</div>';
          timelineContainer.innerHTML = timelineHTML;

          setTimeout(() => {
             if(timelineMainContainer) timelineMainContainer.classList.add('is-visible');
          }, 500);

          const activeLetterEls = timelineContainer.querySelectorAll('.koji-timeline-letter.has-content');

          const updateActiveLetter = () => {
            const scrollPos = track.scrollLeft;
            let activeLetter = availableLetters[0];
            const padding = window.innerWidth >= 990 ? 50 : 24;

            items.forEach(item => {
              if (item.offsetLeft - track.offsetLeft <= scrollPos + padding + 60) {
                activeLetter = item.getAttribute('data-letter');
              }
            });

            activeLetterEls.forEach(el => {
              if (el.getAttribute('data-target-letter') === activeLetter) {
                el.classList.add('is-active');
                const elLeft = el.offsetLeft;
                const timelineHalf = timelineContainer.clientWidth / 2;
                timelineContainer.scrollTo({ left: elLeft - timelineHalf + (el.clientWidth / 2), behavior: 'smooth' });
              } else {
                el.classList.remove('is-active');
              }
            });
          };

          track.addEventListener('scroll', updateActiveLetter);
          window.addEventListener('resize', updateActiveLetter);
          updateActiveLetter(); 
        }
      }

      // =========================================
      // UPDATE FRECCE BASATO SULLO SCROLL E DRAG
      // =========================================
      const updateArrowsVisibility = () => {
        if (!track || !prevBtn || !nextBtn) return;
        
        const scrollLeft = Math.ceil(track.scrollLeft);
        const maxScroll = Math.floor(track.scrollWidth - track.clientWidth);

        if (scrollLeft <= 5) {
          prevBtn.classList.add('is-disabled');
        } else {
          prevBtn.classList.remove('is-disabled');
        }

        if (scrollLeft >= maxScroll - 5) {
          nextBtn.classList.add('is-disabled');
        } else {
          nextBtn.classList.remove('is-disabled');
        }
      };

      if (prevBtn && nextBtn && track) {
        track.addEventListener('scroll', updateArrowsVisibility);
        window.addEventListener('resize', updateArrowsVisibility);
        setTimeout(updateArrowsVisibility, 100);

        const scrollAmount = () => {
          const item = track.querySelector('.koji-pill-item');
          return item ? (item.offsetWidth + parseFloat(window.getComputedStyle(track).gap || 16)) * 3 : 400;
        };

        nextBtn.addEventListener('click', () => {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });

        prevBtn.addEventListener('click', () => {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }

      if (track) {
        let isDown = false;
        let startX;
        let scrollLeft;
        let isDragging = false; 

        track.addEventListener('mousedown', (e) => {
          isDown = true;
          track.style.scrollBehavior = 'auto'; 
          track.style.scrollSnapType = 'none'; 
          startX = e.pageX - track.offsetLeft;
          scrollLeft = track.scrollLeft;
          isDragging = false;
        });

        track.addEventListener('mouseleave', () => {
          isDown = false;
          track.style.scrollBehavior = 'smooth';
          track.style.scrollSnapType = 'x mandatory';
        });

        track.addEventListener('mouseup', () => {
          isDown = false;
          track.style.scrollBehavior = 'smooth';
          track.style.scrollSnapType = 'x mandatory';
        });

        track.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          isDragging = true;
          const x = e.pageX - track.offsetLeft;
          const walk = (x - startX) * 2; 
          track.scrollLeft = scrollLeft - walk;
        });

        const links = track.querySelectorAll('.koji-pill-link-wrapper');
        links.forEach(link => {
          link.addEventListener('click', (e) => {
            if (isDragging) {
              e.preventDefault();
            }
          });
        });
      }
    });

  }); // Fine del ciclo delle sezioni
});